module.exports = __webpack_public_path__ + "img/1509390941.26f5c9c7.jpg";